import { render, staticRenderFns } from "./projectUpdate.vue?vue&type=template&id=0546aa0d&"
import script from "./projectUpdate.vue?vue&type=script&lang=js&"
export * from "./projectUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports